import React from 'react'
import { GAME_TYPE } from '../steps/drag-and-drop/constants'

export const legacyImageURL = image => {
  if (!image) {
    return '' // not sure what a good response is for this
  }

  if (typeof image === 'string') {
    return `${process.env.SITE_ASSET_URL}/${image}`
  }

  return `${process.env.SITE_ASSET_URL}/${image.id}`
}

const BackgroundImage = ({
  image,
  setInteracted,
  style,
  isDropped,
  onClick: onClickProp,
  isBackgroundImage,
  isReplacingBottom,
  gameType,
}) => {
  const onClick = () => {
    setInteracted && setInteracted(true)
    onClickProp && onClickProp()
  }

  if (!image) {
    return false
  }

  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        height: '100%',
        width: '100%',
        borderRadius: isDropped && gameType !== GAME_TYPE.PAIRS ? '0' : '8px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${legacyImageURL(image)})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: `2px solid ${isReplacingBottom ? 'red' : 'gray'}`,
        opacity: isBackgroundImage ? 0.5 : 1,
        ...(isDropped && { cursor: 'pointer' }),
        ...style,
      }}
      alt={image.alt || image.name}
      onClick={onClick}
    ></div>
  )
}

export default BackgroundImage
